import { Language } from "@digipost/translate";

export const AVAILABLE_LANGUAGES: Language[] = ["nb", "nn", "en"] as const;

export const getTermsUrl = (lang: Language) => {
  const uris = {
    nb: "/juridisk/#for-bedrifter",
    nn: "/nn/juridisk#for-bedrifter",
    en: "/en/terms#for-businesses-in-norwegian",
  };

  return getEnvBaseUrl() + uris[lang];
};

export const getEnvBaseUrl = () => {
  const host = location.host;
  if (host.includes("opstest")) {
    return "https://opstest.digipost.no";
  } else if (host.includes("difitest")) {
    return "https://difitest.digipost.no";
  } else if (host.includes("qa")) {
    return "https://qa.digipost.no";
  } else if (host.includes("test")) {
    return "https://test.digipost.no";
  } else if (host.includes("localhost")) {
    return "";
  } else {
    return "https://digipost.no";
  }
};
